// extracted by mini-css-extract-plugin
export default {"sidebar__main":"Sidebar_sidebar__main__8aWZC"};